import { gql, useQuery } from '@apollo/client';
import {
  BrandKey,
  GetAffilizzDesignsQuery,
  GetSearchAffiliationProductQuery,
  GetSearchAffiliationProductQueryVariables,
} from '../../__generated__/queries-web';
import { getMediaId } from '../../pages/ArticleEdit/plugins/affilizz/utils';

const GET_AFFILIZ_PRODUCTS_QUERY = gql`
  query GetSearchAffiliationProduct(
    $keyword: String!
    $minPrice: Float
    $maxPrice: Float
    $sort: AffilizzProductSearchSort
    $page: UnsignedInt
    $size: UnsignedInt
  ) {
    searchAffiliationProduct(
      keyword: $keyword
      minPrice: $minPrice
      maxPrice: $maxPrice
      sort: $sort
      page: $page
      size: $size
    ) {
      totalElements
      totalPages
      pageable {
        pageNumber
      }
      content {
        type
        id
        productLocalizedId
        currencyCode
        defaultImage
        minPrice
        maxPrice
        nbOffers
        name
        upsides
        downsides
      }
    }
  }
`;

export const useGetAffilizzProducts = (
  variables: GetSearchAffiliationProductQueryVariables,
  skip?: boolean,
) =>
  useQuery<
    GetSearchAffiliationProductQuery,
    GetSearchAffiliationProductQueryVariables
  >(GET_AFFILIZ_PRODUCTS_QUERY, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    skip,
    variables,
  });

const GET_AFFILIZ_DESIGNS_QUERY = gql`
  query GetAffilizzDesigns($mediaId: String!) {
    searchAffiliationDesign(mediaId: $mediaId) {
      id
      name
      defaultDesign
      renderingType
    }
  }
`;

export const useGetAffilizzDesigns = (brandKey?: BrandKey, skip?: boolean) =>
  useQuery<GetAffilizzDesignsQuery, any>(GET_AFFILIZ_DESIGNS_QUERY, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    skip,
    variables: { mediaId: getMediaId(brandKey) },
  });
